"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabletPagetLayout = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../common");
const Colors_1 = require("../../../Colors");
exports.TabletPagetLayout = react_1.default.memo(({ pageList, setPage }) => {
    const [tabletPage, setTabletPage] = react_1.default.useState(0);
    const hadlePreviousPage = () => {
        if (tabletPage > 0) {
            setTabletPage(prevPage => prevPage - 1);
        }
    };
    const handleNextPage = () => {
        if (pageList.length >= tabletPage) {
            setTabletPage(prevPage => prevPage + 1);
        }
    };
    (0, react_1.useEffect)(() => {
        setPage(tabletPage);
    });
    return (react_1.default.createElement("div", { className: "field-global-001" },
        tabletPage - 1 >= 0 && (react_1.default.createElement("div", { className: "page", onClick: hadlePreviousPage, style: { cursor: 'pointer', justifyContent: 'flex-start' } },
            react_1.default.createElement(common_1.Icon, { className: "arrow-left", icon: "arrow", size: 22, fill: Colors_1.Colors.w_grey }),
            react_1.default.createElement("p", null, pageList[tabletPage - 1].title))),
        pageList.length > tabletPage + 1 && (react_1.default.createElement("div", { className: "page", onClick: handleNextPage, style: { cursor: 'pointer', justifyContent: 'flex-end' } },
            react_1.default.createElement("p", null, pageList[tabletPage + 1].title),
            react_1.default.createElement(common_1.Icon, { className: "arrow-right", icon: "arrow", size: 22, fill: Colors_1.Colors.w_grey })))));
});
